import { ReactNode } from 'react';
import { useEntity } from '@backstage/plugin-catalog-react';

/**
 * Renders its child card only when the entity actually has matching
 * relations. The stock relation cards render a "No X is a dependency of this
 * component. Learn how to change this." placeholder, which is just noise on
 * the Overview page - especially with five such cards stacked.
 */
export function NonEmptyRelationCard({
  type,
  targetKind,
  children,
}: {
  /** Relation type on the entity, e.g. dependsOn, hasPart, providesApi. */
  type: string;
  /** Only count relations targeting this kind (e.g. component vs resource). */
  targetKind?: string;
  children: ReactNode;
}) {
  const { entity } = useEntity();
  const hasRelation = entity.relations?.some(
    relation =>
      relation.type === type &&
      (!targetKind || relation.targetRef.startsWith(`${targetKind}:`)),
  );
  return hasRelation ? <>{children}</> : null;
}
